import type { EntitySchema } from './types';

// IPL Teams for dropdown options
const IPL_TEAMS = [
  { value: 'MI', label: 'Mumbai Indians' },
  { value: 'CSK', label: 'Chennai Super Kings' },
  { value: 'RCB', label: 'Royal Challengers Bangalore' },
  { value: 'KKR', label: 'Kolkata Knight Riders' },
  { value: 'DC', label: 'Delhi Capitals' },
  { value: 'PBKS', label: 'Punjab Kings' },
  { value: 'RR', label: 'Rajasthan Royals' },
  { value: 'SRH', label: 'Sunrisers Hyderabad' },
  { value: 'GT', label: 'Gujarat Titans' },
  { value: 'LSG', label: 'Lucknow Super Giants' },
];

// Common nationalities
const NATIONALITIES = [
  { value: 'India', label: 'India' },
  { value: 'Australia', label: 'Australia' },
  { value: 'England', label: 'England' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'West Indies', label: 'West Indies' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Zimbabwe', label: 'Zimbabwe' },
];

export const cricketPlayerSchema: EntitySchema = {
  entityType: 'cricket_player',
  displayName: 'Cricket Player',
  description: 'Cricket players with IPL and international statistics',
  categories: [
    {
      name: 'IPL Career Stats',
      description: 'Indian Premier League statistics',
      fields: [
        {
          path: 'career.domestic.ipl.totals.runs',
          label: 'IPL Runs',
          type: 'number',
          operators: ['eq', 'gt', 'gte', 'lt', 'lte', 'between'],
          placeholder: 'e.g., 1000',
          description: 'Total IPL career runs',
        },
        {
          path: 'career.domestic.ipl.totals.wickets',
          label: 'IPL Wickets',
          type: 'number',
          operators: ['eq', 'gt', 'gte', 'lt', 'lte', 'between'],
          placeholder: 'e.g., 50',
          description: 'Total IPL career wickets',
        },
        {
          path: 'career.domestic.ipl.totals.matches',
          label: 'IPL Matches',
          type: 'number',
          operators: ['eq', 'gt', 'gte', 'lt', 'lte', 'between'],
          placeholder: 'e.g., 100',
          description: 'Total IPL matches played',
        },
        {
          path: 'career.domestic.ipl.teams',
          label: 'IPL Teams',
          type: 'array',
          operators: ['contains'],
          options: IPL_TEAMS,
          description: 'Teams played for in IPL',
        },
      ],
    },
    {
      name: 'Personal Information',
      description: 'Basic player information',
      fields: [
        {
          path: 'basic.nationality',
          label: 'Nationality',
          type: 'string',
          operators: ['eq'],
          options: NATIONALITIES,
          description: 'Player nationality',
        },
        {
          path: 'basic.birthDate',
          label: 'Birth Date',
          type: 'date',
          operators: ['eq', 'gt', 'gte', 'lt', 'lte', 'between'],
          placeholder: 'YYYY-MM-DD',
          description: 'Player birth date',
        },
      ],
    },
  ],
};
